module.exports = __webpack_public_path__ + "static/img/weixin.83d13ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/weixin.jpg
// module id = jNy9
// module chunks = 29